export default "__VITE_ASSET__BeurEjW0__"